// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.wizard-container {
  padding: 24px 32px;
  min-width: 760px;
  max-width: 900px;
}
.wizard-container--bounded {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-height: 98vh;
  max-height: 98dvh;
  overflow: hidden;
}

.wizard-title {
  text-align: center;
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
  margin-bottom: 20px;
  font-size: 1.6rem;
  flex-shrink: 0;
}

.wizard-stepper {
  margin-bottom: 28px;
  flex-shrink: 0;
  pointer-events: none;
}
.wizard-stepper ::ng-deep .mat-step-header {
  pointer-events: none;
}
.wizard-stepper ::ng-deep .mat-stepper-horizontal-line {
  border-top-style: dashed;
}

.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.step-header h3 {
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
  margin: 0;
  font-size: 1.1rem;
}

.required-note {
  color: #97002e;
  font-size: 0.85rem;
}

.step-description {
  font-size: 0.88rem;
  margin-bottom: 20px;
  color: #444;
  line-height: 1.5;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0 16px;
  align-items: start;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field--span2 {
  grid-column: span 2;
}

.spec-empty-hint {
  font-size: 0.8rem;
  color: #707070;
  margin: -8px 0 4px;
  font-style: italic;
}

.form-field--full {
  grid-column: 1/-1;
}

.field-label {
  font-size: 0.82rem;
  font-family: "GothamBold", Arial, sans-serif;
  margin-bottom: 4px;
  color: #333;
}

.asterisk {
  color: #97002e;
  margin-left: 2px;
}

.field-help-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: middle;
  margin-left: 4px;
  color: #707070;
  cursor: help;
}

.name-uniqueness-hint {
  font-size: 0.8rem;
  color: #707070;
  margin: 4px 0 0;
  font-style: italic;
}

.full-width {
  width: 100%;
}

.toggle-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  height: 56px;
}

.toggle-label {
  font-size: 0.9rem;
  color: #888;
}
.toggle-label--active {
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
}

.creator-row {
  margin-bottom: 16px;
  font-size: 0.9rem;
}
.creator-row .username {
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
}

.members-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.member-group {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.member-search {
  display: flex;
  flex-direction: column;
  min-width: 280px;
}

.member-chips {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.placeholder {
  font-size: 0.85rem;
  color: #888;
  font-style: italic;
  padding: 8px 0;
}

.step-confirmation {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.step-confirmation__fixed-top,
.step-confirmation__fixed-bottom {
  flex-shrink: 0;
}

.step-confirmation__scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.confirmation-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
}

.confirmation-row {
  display: flex;
  gap: 16px;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}

.confirmation-label {
  min-width: 180px;
  font-family: "GothamBold", Arial, sans-serif;
  color: #555;
  font-size: 0.9rem;
}

.confirmation-value {
  color: #222;
  font-size: 0.9rem;
}

.loading-overlay {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

.create-error-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  margin-top: 16px;
  border-radius: 4px;
  background-color: #fdecea;
  border: 1px solid #f5c6cb;
  color: #7b1c1c;
  font-size: 0.88rem;
  line-height: 1.4;
}

.create-error-icon {
  font-size: 20px;
  line-height: 20px;
  flex-shrink: 0;
  color: #97002e;
}

.step-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.action-btn {
  min-width: 120px;
  height: 42px;
  padding: 0 24px;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 0.9rem;
  cursor: pointer;
  border-radius: 3px;
  transition: background-color 0.2s, color 0.2s;
  text-transform: lowercase;
}
.action-btn--secondary {
  background-color: #fff;
  color: #0b2d71;
  border: 2px solid #0b2d71;
}
.action-btn--secondary:hover:not(:disabled) {
  background-color: rgba(11, 45, 113, 0.06);
}
.action-btn--primary {
  background-color: #0b2d71;
  color: #fff;
  border: 2px solid #0b2d71;
}
.action-btn--primary:hover:not(:disabled) {
  background-color: rgb(7.3806451613, 30.1935483871, 75.8193548387);
}
.action-btn--primary:disabled {
  background-color: #aaa;
  border-color: #aaa;
  cursor: default;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
